<script setup lang="ts">
import { onLaunch, onShow, onHide } from "@dcloudio/uni-app";
import { checkAppUpdate } from "@/utils/updater";
import { useUserStore } from '@/store/user';
import { useCartStore } from '@/store/cart';

onLaunch(() => {
  console.log("App Launch");



});
onShow(() => {
  console.log("App Show");
  try {
    const userStore = useUserStore();
    const cartStore = useCartStore();
    if (userStore.token) {
      cartStore.fetchList(true);
    } else {
      uni.removeTabBarBadge({ index: 2 });
    }
  } catch (e) {
    // 防止 Pinia 未初始化报错（虽然 onShow 应该在 onLaunch 之后）
    console.error(e);
  }
});
onHide(() => {
  console.log("App Hide");
});
</script>
<style></style>
